import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MemberLastAttendance } from '../models/unit.model';
import { DashboardTableCardComponent, DashboardTableColumn } from '@shared/components/dashboard-cards';

@Component({
  selector: 'app-unit-last-attendance-card',
  standalone: true,
  imports: [CommonModule, MatIconModule, DashboardTableCardComponent],
  templateUrl: './unit-last-attendance-card.component.html',
  styleUrl: './unit-last-attendance-card.component.scss'
})
export class UnitLastAttendanceCardComponent {
  @Input() members: MemberLastAttendance[] = [];
  @Input() isLoading = false;
  @Input() errorMessage: string | null = null;
  @Input() showCommunity = false;
  @Output() retryLoad = new EventEmitter<void>();

  readonly pageSize = 7;

  constructor(private readonly router: Router) {}

  get columns(): DashboardTableColumn<MemberLastAttendance>[] {
    return [
      {
        key: 'member',
        label: 'Miembro',
        value: member => `${member.firstName} ${member.lastName}`,
        cellClass: 'col-member wrap-cell'
      },
      {
        key: 'lastAttendanceAt',
        label: 'Ultimo SD',
        align: 'end' as const,
        value: member => this.formatLastAttendanceCell(member),
        cellClass: 'col-last-attendance wrap-cell'
      }
    ];
  }

  daysSinceLastAttendance(member: MemberLastAttendance): number | null {
    if (!member.lastAttendanceAt) {
      return null;
    }

    const today = new Date();
    const attendedAt = new Date(member.lastAttendanceAt);
    today.setHours(0, 0, 0, 0);
    attendedAt.setHours(0, 0, 0, 0);

    const millisecondsPerDay = 1000 * 60 * 60 * 24;
    return Math.max(0, Math.floor((today.getTime() - attendedAt.getTime()) / millisecondsPerDay));
  }

  navigateToMember(personId: string): void {
    this.router.navigate(['/people', personId]);
  }

  private formatAttendanceDate(date: Date): string {
    return new Intl.DateTimeFormat('es-AR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).format(new Date(date));
  }

  private formatLastAttendanceCell(member: MemberLastAttendance): string {
    if (!member.lastAttendanceAt) {
      return 'Sin registro';
    }

    const days = this.daysSinceLastAttendance(member);
    const daysLabel = days === 1 ? '1 dia' : `${days} dias`;
    return `${this.formatAttendanceDate(member.lastAttendanceAt)} (${daysLabel})`;
  }
}
